import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { isAuthenticated } from "services/Auth";
import { routes } from "routes";
import { onOpenAuthPopup } from "components/popups/PopupDispatcher";

export const LoginPage = (): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    isAuthenticated().then((loggedIn: boolean) => {
      if (!loggedIn) {
        onOpenAuthPopup();
      } else {
        navigate(routes.home());
      }
    });
  }, [navigate]);

  return <></>;
};

export default LoginPage;
